import PageHeader from "../PageHeader";
import { ReactComponent as LearnerIcon } from "../../images/learnersimage/learnericon.svg";
import useStyles from "../../../styles";
import ReportHeader from "../../CustomComponent/ReportHeaderNotPreview";
import { Report10Api } from "../../../service/services";
import Loader from "../../CustomComponent/Loader";
import { useState } from "react";

function MonthlySectionReport() {
  const classes = useStyles();
  const [loaderOpen, setLoaderOpen] = useState(false);

  const Heading = [
    {
      id: 1,
      pageicon: <LearnerIcon />,
      mainheading: "Monthly Section Wise Report",
    },
  ];

  return (
    <div className={`${classes.p2} ${classes.pb0} ${classes.pt1}`}>
      <Loader loaderOpen={loaderOpen} />
      <PageHeader Heading={Heading} />
      <ReportHeader isDualDate={true} exportApi={Report10Api} setLoaderOpen={setLoaderOpen} type={"section"} />
    </div>
  );
}
export default MonthlySectionReport;
